import { combineReducers } from 'redux';

import MyShoppingTypes from './types';

export const myShoppingReducer = combineReducers({
  list: MyShoppingTypes.list.getReducer(),
  getFiscalDocuments: MyShoppingTypes.getFiscalDocuments.getReducer(),
  getTickets: MyShoppingTypes.getTickets.getReducer(),
  getSubscriptions: MyShoppingTypes.getSubscriptions.getReducer(),
  getSubscriptionsNext: MyShoppingTypes.getSubscriptionsNext.getReducer(),
  getHistoryPaymentSubscriptions: MyShoppingTypes.getHistoryPaymentSubscriptions.getReducer(),
});
